import type { ReactElement } from 'react';
import type { Device } from '../../../model';
import { DeviceTable } from './table';

interface Props {
  devices?: Device[];
  updateEnabled?: boolean;
  latestLcs?: string;
  latestEms?: string;
  selectDevices: (devices: Device[]) => void;
  showUpdate: (show: boolean) => void;
  unlinkAttempt: (device: Device) => void;
}

export const Devices = (props: Props): ReactElement => <DeviceTable {...props} />;
